import React from "react";
import "../../style/apropos.css";

import aboutImg from "../../images/about-us2.png";

const chooseData = [
  {
    icon: "ri-wifi-line",
    title: "Process De Travail Qualifié",
    desc: "De l'idée à la livraison, vous êtes au courant de toutes les étapes et participez à la réalisation de votre projet dans les délais.",
  },
  {
    icon: "ri-team-line",
    title: "Equipe Dédiée",
    desc: "Nous avons une équipe de professionnels qualifiés et expérimentés. Des ingénieurs dans tous les domaines de la Tech.",
  },
  {
    icon: "ri-customer-service-2-line",
    title: "Assistance 24h/24 et 7j/7",
    desc: "Un agent de contact est mis à votre disposition jusqu'à la réalisation de votre projet. ",
  },
];

const Apropos = () => {
  return (
    <section id="about">
      <div className="container">
        <div className="about__wrapper">
          <div className="about__content">
            <h6 className="subtitle">Pourquoi Nous?</h6>
            <h2>Spécialiste de l'accompagnement des clients sur</h2>
            <h2 className="highlight">tous les enjeux financiers</h2>
            <p className="description about__content-desc">
              Membre de l’association French Tech depuis 2021, notre agence vous
              conseille lors de la création d’application ou de développement
              sur-mesure, partout en Afrique, aussi bien en français, en anglais
              ou toute autre langue.
            </p>
            <div className="choose__item-wrapper">
              {chooseData.map((item, index) => (
                <div className={"choose__us-item"} key={index}>
                  <span className="choose__us-icon">
                    <i class={item.icon}></i>
                  </span>
                  <div>
                    <h4 className="choose__us-title">{item.title}</h4>
                    <p className="description">{item.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
          <div className="about__img">
            <img src={aboutImg} alt="about" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Apropos;
